import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class SwiperNews {
    constructor() {
        console.log('%c👍🏼 Swiper News Cards', 'color: yellow');
        
        this.swiperNews = document.querySelectorAll(
            '.swiper--news'
        )
    }
    init() {
        this.swiperNews.forEach((elem, i) => {
            
            let swiper;
            let init = false;
            let wrapper = elem.querySelector('.swiper-wrapper');

            let onresize = function (e) {
                if (window.innerWidth <= 768) {
                    if (!init) {
                        init = true;
                        wrapper.classList.remove('row');
                        swiper = new Swiper(elem, {
                            slidesPerView: 1.5,
                            loop: true,
                            spaceBetween: 30,
                            speed: 1001,
                            autoplay: {
                                delay: 10000,
                                disableOnInteraction: true
                            },
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                        });                
                    } 
                } else if (init) {
                    wrapper.classList.add('row');
                    swiper.destroy();
                    init = false;
                }
            }
            onresize();
            window.addEventListener("resize", onresize);
        })
    }
}

